@if (initComplete) {
  <router-outlet></router-outlet>
}

<p-toast key="GLOBAL_TOAST_KEY" position="bottom-left"></p-toast>
<p-confirmDialog
  key="GLOBAL_CONFIRMATION_KEY"
  styleClass="confirm-dialog"
  rejectButtonStyleClass="p-button-secondary"
></p-confirmDialog>
